import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';

export const EmergencyContactSection = ({ formData, handleChange }) => (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg font-semibold font-[Manrope]">Emergency Contact</CardTitle>
      </CardHeader>
      <CardContent className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="emergency_contact">Contact Name</Label>
          <Input
            id="emergency_contact"
            value={formData.emergency_contact}
            onChange={(e) => handleChange('emergency_contact', e.target.value)}
            placeholder="Emergency contact name"
            data-testid="input-emergency-contact"
          />
        </div>

        <div>
          <Label htmlFor="emergency_phone">Contact Phone</Label>
          <Input
            id="emergency_phone"
            type="tel"
            value={formData.emergency_phone}
            onChange={(e) => handleChange('emergency_phone', e.target.value)}
            placeholder="+91 XXXXXXXXXX"
            data-testid="input-emergency-phone"
          />
        </div>
      </CardContent>
    </Card>

);
